import Vue from 'vue/dist/vue.esm'

Vue.component("navigation-search-vue", () => import(/* webpackChunkName: "[request]" */ "components/NavigationSearch"))

Vue.component("breadcrumb-vue", () => import(/* webpackChunkName: "[request]" */ "components/Breadcrumb"))
